import { useEffect, useState } from "react";

import { fieldNames } from "../utilities/constants";
import { Tool, sortTools } from "../utilities/utils";

const { CATALOGUES } = fieldNames;

function SpanishTools(props) {
  const [data, setData] = useState([]);
  const [spanishTools, setSpanishTools] = useState(3);

  useEffect(() => {
    let data = [];
    props.records.forEach((record) => {
      const catalogues = record.get(CATALOGUES);
      if (catalogues && catalogues.includes("Spanish Tools")) {
        data.push(record);
      }
    });

    const sortedData = sortTools(data, props.sortInfo);

    setData(sortedData);
  }, [props.sortInfo, props.records]);

  const card = data.slice(0, spanishTools).map((i) => Tool(i));
  return (
    <div id="spanish-tools-container">
      {card}
      {data.length === null || spanishTools >= data.length ? null : (
        <button onClick={() => setSpanishTools(spanishTools + 3)}>
          see more
        </button>
      )}
    </div>
  );
}

export default SpanishTools;
